/* Verlanglijst
   Een tik op een hartje bewaart de lamp in de browser van de klant, zonder
   inloggen. Bij een volgend bezoek op hetzelfde apparaat staat de lijst er nog.
   Het hartje in de kop telt mee en opent een paneel in de stijl van de mand.

   Herkennen gaat op het productnummer: het adres van een lamp (handle)
   verschilt per taal, het nummer niet. Met het adres haalt het paneel de regel
   op; Shopify stuurt een adres uit elke taal door naar dat van de bezoeker.

   Naar een ander apparaat gaat de lijst via de mail: een link met
   ?wishlist=nummer:adres,nummer:adres zet hem daar terug. Kent Klaviyo de
   bezoeker, dan krijgt Klaviyo bij elke wijziging een melding. */
(function () {
  var SLEUTEL = 'tav-verlanglijst';
  var MAX = 60;
  var cfg = window.tavVerlanglijst || {};
  var T = cfg.teksten || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---- de lijst zelf ---- */
  function lees() {
    try {
      var v = JSON.parse(window.localStorage.getItem(SLEUTEL) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && (x.id || x.h); }) : [];
    } catch (e) { return []; }
  }
  function schrijf(lijst) {
    try { window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst.slice(0, MAX))); } catch (e) {}
    bijwerken();
  }
  /* hoort dit item bij dit nummer of adres; een item uit een maillink heeft
     soms nog geen nummer, dan telt het adres */
  function zelfde(x, id, h) {
    if (x.id && id) return String(x.id) === String(id);
    return !!(x.h && h && x.h === h);
  }

  function itemUit(el) {
    return {
      id: el.getAttribute('data-tav-bewaar'),
      h: el.getAttribute('data-tav-handle') || '',
      t: el.getAttribute('data-tav-titel') || '',
      i: el.getAttribute('data-tav-foto') || '',
      p: el.getAttribute('data-tav-prijs') || '',
      u: el.getAttribute('data-tav-url') || '',
      a: el.getAttribute('data-tav-voorraad') === '0' ? 0 : 1,
      d: Date.now()
    };
  }

  function absoluut(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return location.origin + u;
    return u;
  }
  function herstelUrl(lijst) {
    return location.origin + root + '?wishlist=' + lijst.map(function (x) {
      return (x.id ? x.id + ':' : '') + encodeURIComponent(x.h || '');
    }).join(',');
  }

  /* ---- hartjes en teller op de pagina ---- */
  function bijwerken() {
    var lijst = lees();
    document.querySelectorAll('[data-tav-bewaar]').forEach(function (el) {
      var id = el.getAttribute('data-tav-bewaar');
      var h = el.getAttribute('data-tav-handle');
      var aan = lijst.some(function (x) { return zelfde(x, id, h); });
      el.classList.toggle('is-bewaard', aan);
      el.setAttribute('aria-pressed', aan ? 'true' : 'false');
      var label = el.getAttribute(aan ? 'data-tav-label-aan' : 'data-tav-label-uit');
      if (label) el.setAttribute('aria-label', label);
    });
    document.querySelectorAll('[data-tav-verlanglijst-teller]').forEach(function (t) {
      t.textContent = lijst.length;
      t.hidden = lijst.length === 0;
    });
    var aantal = document.querySelector('[data-tav-verlanglijst-aantal]');
    if (aantal) aantal.textContent = lijst.length || '';
    var lade = document.querySelector('[data-tav-verlanglijst]');
    if (lade) lade.classList.toggle('is-empty', lijst.length === 0);
  }

  function puls(el) {
    if (!el) return;
    el.classList.remove('tav-hart--puls', 'tav-verlanglijst-open--puls');
    void el.offsetWidth;
    el.classList.add(el.hasAttribute('data-tav-bewaar') ? 'tav-hart--puls' : 'tav-verlanglijst-open--puls');
  }

  function zet(el) {
    var item = itemUit(el);
    if (!item.id) return;
    var lijst = lees();
    var was = lijst.some(function (x) { return zelfde(x, item.id, item.h); });
    if (was) {
      lijst = lijst.filter(function (x) { return !zelfde(x, item.id, item.h); });
    } else {
      lijst.unshift(item);
    }
    schrijf(lijst);
    puls(el);
    if (!was) document.querySelectorAll('[data-tav-verlanglijst-open]').forEach(puls);
    meldAanKlaviyo(was ? 'Removed from Wishlist' : 'Added to Wishlist', item, lijst);
  }

  /* ---- Klaviyo: alleen voor bezoekers die Klaviyo al kent ---- */
  function kortItem(x) {
    return { product_id: x.id, handle: x.h, title: x.t, url: absoluut(x.u), image: absoluut(x.i), price: x.p, available: x.a !== 0 };
  }
  function opVoorraad(lijst) {
    return lijst.filter(function (x) { return x.a !== 0; }).length;
  }
  function lijstEigenschappen(lijst) {
    return {
      Items: lijst.map(kortItem),
      ItemNames: lijst.map(function (x) { return x.t; }),
      Count: lijst.length,
      AvailableCount: opVoorraad(lijst),
      WishlistURL: herstelUrl(lijst),
      Locale: cfg.taal || '',
      Country: cfg.land || '',
      Currency: cfg.munt || ''
    };
  }
  function meldAanKlaviyo(naam, item, lijst) {
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return;
    Promise.resolve(k.isIdentified()).then(function (bekend) {
      if (!bekend) return;
      var props = lijstEigenschappen(lijst);
      props.ProductID = item.id;
      props.ProductHandle = item.h;
      props.ProductName = item.t;
      props.URL = absoluut(item.u);
      props.ImageURL = absoluut(item.i);
      props.Price = item.p;
      k.track(naam, props);
      k.identify(profielEigenschappen(lijst));
    }).catch(function () {});
  }
  /* op het profiel staat altijd de lijst zoals hij nu is; de herinnering leest
     die bij het versturen, dus ook wat de klant intussen bewaarde of weghaalde */
  function profielEigenschappen(lijst) {
    return {
      'Wishlist Items': lijst.map(function (x) { return x.t; }),
      'Wishlist Products': lijst.slice(0, 12).map(kortItem),
      'Wishlist Product IDs': lijst.map(function (x) { return x.id; }).join(','),
      'Wishlist URL': herstelUrl(lijst),
      'Wishlist Count': lijst.length,
      'Wishlist Available Count': opVoorraad(lijst),
      'Wishlist Locale': cfg.taal || '',
      'Wishlist Country': cfg.land || ''
    };
  }

  /* ---- het paneel ---- */
  var lade, lijstVak, vorigeFocus;

  function open() {
    lade = lade || document.querySelector('[data-tav-verlanglijst]');
    if (!lade) return;
    vorigeFocus = document.activeElement;
    lade.classList.remove('is-closing');
    lade.classList.add('is-open');
    lade.setAttribute('aria-hidden', 'false');
    var inner = lade.querySelector('.drawer__inner');
    if (inner) inner.setAttribute('aria-modal', 'true');
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
    vul();
    var sluitKnop = lade.querySelector('.drawer__close');
    if (sluitKnop) setTimeout(function () { sluitKnop.focus(); }, 50);
  }
  function sluit() {
    if (!lade || !lade.classList.contains('is-open')) return;
    lade.classList.add('is-closing');
    lade.classList.remove('is-open');
    lade.setAttribute('aria-hidden', 'true');
    var inner = lade.querySelector('.drawer__inner');
    if (inner) inner.removeAttribute('aria-modal');
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    setTimeout(function () { lade.classList.remove('is-closing'); }, 420);
    if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus();
  }

  /* Elke regel komt van Shopify zelf, zodat prijs, munt, taal en voorraad
     altijd kloppen met wat de klant ziet. */
  function vul() {
    lijstVak = lijstVak || lade.querySelector('[data-tav-verlanglijst-lijst]');
    var lijst = lees();
    bijwerken();
    if (!lijst.length) { lijstVak.innerHTML = ''; return; }
    lijstVak.innerHTML = '<p class="tav-verlanglijst__laden">' + (T.laden || '') + '</p>';
    Promise.all(lijst.map(function (x) {
      return fetch(root + 'products/' + encodeURIComponent(x.h) + '?section_id=tav-verlanglijst-regel', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? '404' : ''); })
        .catch(function () { return ''; });
    })).then(function (stukken) {
      var weg = [];
      var aangevuld = false;
      var nu = lees();
      var html = '';
      stukken.forEach(function (s, i) {
        var x = lijst[i];
        if (s === '404') { weg.push(x); return; }
        if (!s) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = s;
        var regel = tmp.querySelector('.cart__item');
        if (!regel) return;
        html += regel.outerHTML;
        /* elk item krijgt hier zijn nummer, en naam, adres, foto en prijs in deze taal en munt,
           zodat ook de mail klopt met wat de klant nu ziet */
        var vers = {
          id: regel.getAttribute('data-tav-id'),
          h: regel.getAttribute('data-tav-handle'),
          t: regel.getAttribute('data-tav-titel'),
          u: regel.getAttribute('data-tav-url'),
          i: regel.getAttribute('data-tav-foto'),
          p: regel.getAttribute('data-tav-prijs'),
          a: regel.getAttribute('data-tav-voorraad') === '0' ? 0 : 1
        };
        nu.forEach(function (y) {
          if (!zelfde(y, x.id, x.h)) return;
          Object.keys(vers).forEach(function (k) {
            if ((vers[k] || vers[k] === 0) && y[k] !== vers[k]) { y[k] = vers[k]; aangevuld = true; }
          });
        });
      });
      /* een lamp die niet meer bestaat, verdwijnt stil uit de lijst */
      if (weg.length) {
        nu = nu.filter(function (y) { return !weg.some(function (x) { return zelfde(y, x.id, x.h); }); });
      }
      if (weg.length || aangevuld) schrijf(nu);
      lijstVak.innerHTML = html;
    });
  }

  function inMand(knop) {
    var id = knop.getAttribute('data-tav-variant');
    if (!id) return;
    knop.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      knop.disabled = false;
      if (!r.ok) throw new Error('add');
      sluit();
      /* het thema haalt de mand opnieuw op; daarna de mandlade open, zoals de mandknop in de kop */
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      var lade = document.querySelector('cart-drawer');
      if (lade) {
        setTimeout(function () { lade.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 350);
      } else {
        window.location.href = root + 'cart';
      }
    }).catch(function () { knop.disabled = false; });
  }

  /* ---- de lijst naar je eigen mail ---- */
  function mail(form) {
    var veld = form.querySelector('input[type="email"]');
    var melding = form.querySelector('[data-tav-verlanglijst-melding]');
    var knop = form.querySelector('button[type="submit"]');
    var adres = (veld.value || '').trim();
    function zeg(tekst, fout) {
      /* de vertaling komt html-veilig uit Liquid (&#39; voor een apostrof); terugzetten naar gewone tekst */
      var omzetter = document.createElement('textarea');
      omzetter.innerHTML = tekst || '';
      melding.textContent = omzetter.value;
      melding.hidden = false;
      melding.classList.toggle('is-fout', !!fout);
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) { zeg(T.mail_ongeldig, true); veld.focus(); return; }
    var k = window.klaviyo;
    var lijst = lees();
    if (!k || typeof k.identify !== 'function' || !lijst.length) { zeg(T.mail_fout, true); return; }
    knop.disabled = true;
    var profiel = profielEigenschappen(lijst);
    profiel.email = adres;
    Promise.resolve(k.identify(profiel)).then(function () {
      return k.track('Wishlist Emailed', lijstEigenschappen(lijst));
    }).then(function () {
      knop.disabled = false;
      veld.value = '';
      zeg(T.mail_klaar, false);
    }).catch(function () {
      knop.disabled = false;
      zeg(T.mail_fout, true);
    });
  }

  /* ---- terugzetten via de link uit de mail ---- */
  function herstel() {
    var params = new URLSearchParams(location.search);
    var ruw = params.get('wishlist');
    if (!ruw) return false;
    var lijst = lees();
    ruw.split(',').reverse().forEach(function (deel) {
      var stukken = decodeURIComponent(deel).trim().split(':');
      var id = stukken.length > 1 && /^\d+$/.test(stukken[0]) ? stukken[0] : '';
      var h = stukken[stukken.length - 1];
      if (!/^[a-z0-9][a-z0-9-]*$/i.test(h)) return;
      if (!lijst.some(function (x) { return zelfde(x, id, h); })) {
        lijst.unshift({ id: id, h: h, t: '', i: '', p: '', u: root + 'products/' + h, d: Date.now() });
      }
    });
    schrijf(lijst);
    params.delete('wishlist');
    var rest = params.toString();
    history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
    return true;
  }

  /* ---- alles aan elkaar ---- */
  document.addEventListener('click', function (e) {
    var hart = e.target.closest('[data-tav-bewaar]');
    if (hart) { e.preventDefault(); e.stopPropagation(); zet(hart); return; }
    if (e.target.closest('[data-tav-verlanglijst-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-tav-verlanglijst-sluit]')) { e.preventDefault(); sluit(); return; }
    var mand = e.target.closest('[data-tav-variant]');
    if (mand) { e.preventDefault(); inMand(mand); return; }
    var wegKnop = e.target.closest('[data-tav-verlanglijst-weg]');
    if (wegKnop) {
      e.preventDefault();
      var regel = wegKnop.closest('.cart__item');
      var id = wegKnop.getAttribute('data-tav-verlanglijst-weg');
      var h = regel ? regel.getAttribute('data-tav-handle') : '';
      var oud = lees().filter(function (x) { return zelfde(x, id, h); })[0];
      schrijf(lees().filter(function (x) { return !zelfde(x, id, h); }));
      if (regel) regel.remove();
      if (oud) meldAanKlaviyo('Removed from Wishlist', oud, lees());
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-tav-verlanglijst-mail]')) { e.preventDefault(); mail(e.target); }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') sluit(); });

  /* ook voor kaarten die later bijkomen, zoals na "meer laden"; even wachten
     zodat een golf aan wijzigingen maar één keer telt */
  var wachter;
  new MutationObserver(function (lijst) {
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i].addedNodes.length) {
        clearTimeout(wachter);
        wachter = setTimeout(bijwerken, 120);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* een wijziging in een ander tabblad volgt hier vanzelf */
  window.addEventListener('storage', function (e) { if (e.key === SLEUTEL) bijwerken(); });

  function start() {
    var hersteld = herstel();
    bijwerken();
    if (hersteld) open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
